export default import.meta.ROLLDOWN_FILE_URL_stgHNk4_TpJ333nyAmmqBQ